// extracted by mini-css-extract-plugin
export default {"container":"AsQi0c","error":"a24v9O"};